export default __webpack_public_path__ + "static/media/Oops.47278325.svg";